
export const ProductTexts = {
  Producttitle: {
      ko: (
        <>
          세계적으로 검증된 최고 수준의 보안 솔루션
        </>
      ),
      en: (
        <>
          World-class security solutions validated globally
        </>
      )
  },
    Halcyontitle: {
      ko: (
        <>
          (미국 제품)<br/>
          랜섬웨어 탐지 및 복구 솔루션
        </>
      ),
      en: (
        <>
          Ransomware Intrusion Detection and Automated Recovery Solution
        </>
      )
  },
  Halcyonmessage: {
      ko: (
        <>
          Halcyon은 랜섬웨어가 침투전, 암호화중, 침투후를 모두 고려하여 랜섬웨어로 부터
          자산을 안전하게 지키줄수 있는 솔루션으로 특히, 암호화키 자동 캡쳐기능을 이용하여
          암호화된 파일을 자동 복호화할 수 있습니다.
        </>
      ),
      en: (
        <>
          Halcyon is a solution that considers all stages of ransomware attacks
          - before, during, and after encryption - to protect assets from ransomware.
          In particular, it utilizes an automatic encryption key capture feature
          to automatically decrypt encrypted files.
        </>
      )
  },
  Primxtitle: {
      ko: (
        <>
          (프랑스 제품)<br/>
          초고속 암호화 솔루션
        </>
      ),
      en: (
        <>
          Ultra-Fast Encryption Solution
        </>
      )
  },
  Primxmessage: {
      ko: (
        <>
          PRIMX의 ZONECENTRAL은 커널 드라이버로 지정한 폴더에 보관한는 모든 파일을 초고속으로 암호화 합니다.
          파일의 종류 및 사이즈와 상관없이 암호화 하여 사용자의 파일을 안전하게 보호합니다.
        </>
      ),
      en: (
        <>
          PRIMX's ZONECENTRAL is a kernel-level driver that
          encrypts all files in the designated SafetyZone at ultra-fast speeds.
          <br />It encrypts regardless of file type and size,
          safeguarding the user's files.
        </>
      )
  },
  Kosmostitle: {
      ko: (
        <>
        (미국 제품)<br/>
          LiveID 인증 솔루션
        </>
      ),
      en: (
        <>
          LiveID Authentication Solution
        </>
      )
  },
  Kosmosmessage: {
      ko: (
        <>
          1KOSMOS는 비밀번호없이 생동적 얼굴인식(LiveID)을 통해
          진짜 본인 인지를 확실히 확인하는 최신 인증 솔루션.
          참 인증이 필수인 모든 경우에 적용할 수 있고, 사용자 편의 제공과 개인 정보 보호를
          완벽하게 보장합니다.
        </>
      ),
      en: (
        <>
          1KOSMOS is a true authentication solution that verifies if you are the real person
          through Passwordless LiveID.
          It can be applied to all services requiring authentication,
          enhancing user experience without compromising security.
        </>
      )
  },
  ObserveITtitle: {
      ko: (
        <>
        (미국 제품)<br/>
          내부자 위협 관리 솔루션
        </>
      ),
      en: (
        <>
          Insider Threat Management Solution
        </>
      )
  },
  ObserveITmessage: {
      ko: (
        <>
          Proofpoint의 ObserveIT는 사용자의 위협을 감지합니다.
          IT 자산을 보호하기 위해 사용자의 모든 행위를 항상 관찰하여 
          위협 가능성을 사전에 인지하거나 위협 발생 후 그 원인을 조속히 파악할 수 있습니다. 
        </>
      ),
      en: (
        <>
          Proofpoint's ObserveIT detects user threats.
          It helps monitor all user actions and detect threats
          to keep IT assets safe.
        </>
      )
  },
  Mobileumtitle: {
      ko: (
        <>
        (미국 제품)<br/>
          통신사 전문 보안 솔루션
        </>
      ),
      en: (
        <>
          Telecom Security Solution
        </>
      )
  },
  Mobileummessage: {
      ko: (
        <>
          Mobileum은 통신회사(SKT,KT,LGU+)를 고객으로 다양한 IT 플랫폼 및 솔루션을 제공하는 세계적인 회사입니다.
        </>
      ),
      en: (
        <>
          Mobileum provides various security features to ensure 
          that telecom operators and users can deliver services securely.
        </>
      )
  },
  Detailbtn: {
      ko: (
        <>
          자세히 보기
        </>
      ),
      en: (
        <>
          Read More
        </>
      )
  }
};

